
import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import RouterPropsWrapper from "../../../../common/RouterPropsWrapper";
import PlacementForm from "../../../placement/PlacementForm";
import SecondStepChallengeLayout from "../SecondStepChallengeLayout";
import {
  evaluateSecondStep,
  evaluateThirdStep
} from "../../../../settings/commonFunctions";

import * as Yup from 'yup';
import LoadingAnimation from "../../../../common/components/base/LoadingAnimation";
import { useChallengeInstance } from "../../../../hooks/useChallengeInstance";

const placementSchema = Yup.object().shape({
  name: Yup.string()
    .required('Please enter a name.'),
  size: Yup.string()
    .required('Please select a size.'),
});

const AdvertisersAdServerStep2 = (props) => {
  const { match, history } = props;
  const challengeId = match.params.id;
  
  const [isClicked, setIsClicked] = useState(false);
  const [stepTime, setStepTime] = useState(0);
  
  // Fetch challenge instance data
  const { data: challengeInstanceData, isLoading, error } = useChallengeInstance(challengeId);

  // Start step timer
  useEffect(() => {
    const timer = setInterval(() => {
      setStepTime(prevTime => prevTime + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const coreSubmit = async (values) => {
    const action = {
      actionNeeded: "complete",
      target: JSON.stringify({
        fields:{
          placementName: values.name.trim(),
          placementSize: values.size
        }
      }),
      stepTime: stepTime
    };
    let res = await evaluateSecondStep(action, challengeId);
    let value = res.data.challengeStepEvaluator;
    if (value) {
      let finalRes = await evaluateThirdStep(challengeId);
      if (finalRes?.challengeStepEvaluator) history.push(finalRes.challengeStepEvaluator.targetLocation + challengeId);
    }
  };

  const submit = (values) => {
    if (!isClicked) {
      setIsClicked(true);
      coreSubmit(values).then(() => {
        setTimeout(() => {
          setIsClicked(false);
        }, 800);
      });
    }
  };

  if (isLoading) return <LoadingAnimation />;
  if (error) return <div>Error loading challenge: {error.message}</div>;
  if (!challengeInstanceData?.challengeInstance?.challengeType) return <LoadingAnimation />;

  const challengeType = challengeInstanceData.challengeInstance.challengeType;

  return (
    <SecondStepChallengeLayout pageName={"Placements"} challengeType={challengeType}>
      <Formik
        initialValues={{ name: "", size:"" }}
        //validate={validatePlacement}
        validationSchema={placementSchema}
        onSubmit={submit}
      >
        {({ isSubmitting, values, handleChange, setFieldValue, handleSubmit, errors, touched }) => (
          <PlacementForm
            values={values}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            size="Size"
            setFieldValue={setFieldValue}
            touched={touched}
            errors={errors}
          />
        )}
      </Formik>
    </SecondStepChallengeLayout>
  );
};

export default RouterPropsWrapper(AdvertisersAdServerStep2);
